import { useLayoutEffect, useRef, useState } from 'react'
import cx from 'classnames'
import RCSlider, { SliderProps } from 'rc-slider'

import 'rc-slider/assets/index.css'
import styles from './ValidationSlider.module.css'

const ValidationSlider = (props: SliderProps) => {
  const [value, setValue] = useState(0)
  const wrapperRef = useRef<HTMLDivElement | null>(null)

  useLayoutEffect(() => {
    if (wrapperRef.current) {
      const wrapper = wrapperRef.current
      const width = wrapper.offsetWidth
      const sliderTrack = wrapper.querySelector<HTMLElement>(
        '.rc-slider-track::before'
      )
      if (sliderTrack) {
        sliderTrack.style.width = `${width}px`
      }
    }
  })

  const marks = { 100: ' ' }

  return (
    <div
      className={cx(styles.container, {
        [styles.hideDottedSkull]: value === 100,
      })}
      ref={wrapperRef}
    >
      <RCSlider
        {...props}
        marks={marks}
        value={value}
        onChange={(value) => {
          setValue(value as number)
          props.onChange?.(value)
        }}
      />
    </div>
  )
}

export default ValidationSlider
